import { ready, onceInitialized } from '../../lib/lifecycle/ready';
import { initFancybox, destroyFancybox } from '../../lib/lightbox/fancyboxInit';

function initGallery(root) {
  const scope = root || document;
  const { Carousel, Autoplay } = window;

  const fancyboxSelectors = [];
  const carouselInstances = [];

  // Initialize FancyApps Lightbox for galleries
  const lightboxElements = scope.querySelectorAll('.wp-block-modulr-gallery[data-gallery-id]');

  lightboxElements.forEach((galleryElement) => {
    if (!onceInitialized(galleryElement, 'gallery-lightbox')) return;

    const galleryId = galleryElement.dataset.galleryId;
    const selector = `a.gallery-item-link[data-fancybox="${galleryId}"]`;
    const lightboxLinks = galleryElement.querySelectorAll(selector);

    if (lightboxLinks.length === 0) {
      return;
    }

    initFancybox(selector);
    fancyboxSelectors.push(selector);
  });

  // Initialize FancyApps Carousel for carousel mode galleries
  if (Carousel) {
    const carouselElements = scope.querySelectorAll('.wp-block-modulr-gallery.gallery-carousel .f-carousel.init');
    const defaultIcon = '<svg width="15" height="19" viewBox="0 0 15 19" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M14.9899 9.58594L-0.010148 0.925683V18.2462L14.9899 9.58594ZM0.711914 11.0859H1.48985V8.08594H0.711914V11.0859Z" fill="white"/></svg>';

    carouselElements.forEach((carouselElem) => {
      const transition = carouselElem.dataset.transition || 'slide';
      const duration = parseInt(carouselElem.dataset.duration, 10) || 5000;
      const slidesPerPage = parseInt(carouselElem.dataset.slidesPerPage, 10) || 1;
      const enableAutoplay = carouselElem.dataset.autoplay !== 'false';
      const customIconUrl = carouselElem.dataset.arrowIconUrl;

      const arrowIcon = customIconUrl
        ? `<img src="${customIconUrl}" alt="Arrow" style="width: 100%; height: 100%; object-fit: contain;" />`
        : defaultIcon;

      const options = {
        center: true,
        Dots: true,
        fill: true,
        infinite: true,
        Navigation: {
          nextTpl: arrowIcon,
          prevTpl: arrowIcon,
        },
        slidesPerPage: slidesPerPage,
        transition: transition,
      };

      if (enableAutoplay && Autoplay) {
        options.Autoplay = {
          showProgress: true,
          timeout: duration,
        };
      }

      carouselElem.classList.remove('init');

      let instance;
      if (enableAutoplay && Autoplay) {
        instance = new Carousel(carouselElem, options, { Autoplay });
      } else {
        instance = new Carousel(carouselElem, options);
      }
      if (instance) carouselInstances.push(instance);
    });
  }

  return function destroy() {
    fancyboxSelectors.forEach((sel) => destroyFancybox(sel));
    carouselInstances.forEach((instance) => {
      if (instance && typeof instance.destroy === 'function') {
        try { instance.destroy(); } catch (e) { /* ignore */ }
      }
    });
  };
}

ready(initGallery, { scope: 'modulr-gallery' });
